import { createContext } from 'react';

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  tenantId: string | null;
}

export interface AuthContextValue {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  updateProfile: (data: Partial<AuthUser>) => void;
}

/**
 * The context object lives in its own non-component module so both the provider
 * and the useAuth hook can import it without tripping React Fast Refresh
 * (which requires component files to export only components).
 */
export const AuthContext = createContext<AuthContextValue | null>(null);
